import * as React from 'react';
const WarningExclaimation = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#D45C19"
        d="M8 11.154c.153 0 .28-.052.384-.155a.521.521 0 0 0 .154-.384.52.52 0 0 0-.154-.383.521.521 0 0 0-.384-.155.521.521 0 0 0-.384.155.52.52 0 0 0-.154.383c0 .153.051.28.154.384a.521.521 0 0 0 .384.155Zm0-2.436c.142 0 .26-.048.356-.144a.484.484 0 0 0 .144-.356v-3a.484.484 0 0 0-.144-.356A.484.484 0 0 0 8 4.718a.483.483 0 0 0-.356.144.484.484 0 0 0-.144.356v3c0 .141.048.26.144.356A.484.484 0 0 0 8 8.718Zm.001 5.615a6.17 6.17 0 0 1-2.47-.498A6.398 6.398 0 0 1 3.52 12.48a6.395 6.395 0 0 1-1.354-2.01 6.164 6.164 0 0 1-.5-2.47c0-.876.167-1.7.5-2.47A6.398 6.398 0 0 1 3.518 3.52a6.394 6.394 0 0 1 2.01-1.355A6.164 6.164 0 0 1 8 1.667c.876 0 1.7.166 2.47.498.77.333 1.441.784 2.011 1.354.57.57 1.022 1.24 1.354 2.01.333.77.5 1.594.5 2.47 0 .876-.167 1.699-.5 2.47a6.4 6.4 0 0 1-1.353 2.011 6.394 6.394 0 0 1-2.01 1.354 6.165 6.165 0 0 1-2.47.5Z"
      />
    </g>
  </svg>
);
export default WarningExclaimation;
